<script>
  import AccountAppRedirect from '@dabble/components/AccountAppRedirect.svelte';
  import { billingPortalUrl, planPickerUrl } from '@dabble/data/account-urls';
  import Route from '@dabble/toolkit/Route.svelte';
</script>

<Route path="/account/billing"><AccountAppRedirect to={billingPortalUrl} /></Route>
<Route path="/account/billing/cancel"><AccountAppRedirect to={billingPortalUrl} /></Route>
<Route path="/checkout/*"><AccountAppRedirect to={planPickerUrl} /></Route>
